import { computed } from 'vue';
import { black87, secondaryMagenta } from '@/constants/colors';
import store from '@/store';
import { GET_IS_SHOW_SEARCH_FIELD, SET_IS_SHOW_SEARCH_FIELD } from '@/store/constants';

const useHeaderMobile = () => {
  const isShowSearch = computed((): boolean =>
    store.getters[GET_IS_SHOW_SEARCH_FIELD]);
  const closeSearch = (): void => {
    store.commit(SET_IS_SHOW_SEARCH_FIELD, false);
  };
  const openSearch = (): void => {
    store.commit(SET_IS_SHOW_SEARCH_FIELD, true);
  };

  return {
    black87,
    closeSearch,
    isShowSearch,
    openSearch,
    secondaryMagenta,
  };
};

export default useHeaderMobile;
